module.exports = __webpack_public_path__ + "static/media/3.c3485e84.jpg";